let speciesFlkty; 

function initSpeciesSlider() {
	const slider = document.querySelector(
		".species-spotlight .species-spotlight__slider"
	);
	if (!slider) return null;

	if (slider.classList.contains("flickity-enabled")) {
		// If it's already initialized but potentially broken, destroy and reinitialize
		const existingFlickity = Flickity.data(slider);
		if (existingFlickity) existingFlickity.destroy();
	}

	try {
		const flkty = new Flickity(slider, {
			cellAlign: "left",
			contain: true,
			groupCells: 1,
			pageDots: false,
			prevNextButtons: true,
			draggable: true,
			wrapAround: false,
			percentPosition: true,
			freeScroll: false,
			rightToLeft: false,
			adaptiveHeight: true,
		});

		// Make sure to reposition cells after all images are loaded
		slider.querySelectorAll("img").forEach(img => {
			if (!img.complete) {
				img.onload = () => {
					flkty.resize();
				};
			}
		});

		initPopups(flkty);

		// Store the reference globally
		speciesFlkty = flkty;

		return flkty;
	} catch (error) {
		console.error("Error initializing Flickity:", error);
		return null;
	}
}

function initPopups(flickityInstance) {
	if (!flickityInstance) return;

	const slider = flickityInstance.element;
	const popupButtons = slider.querySelectorAll(
		".species-spotlight__popup-button"
	);
	const closeButtons = slider.querySelectorAll(
		".species-spotlight__popup-close"
	);

	function closeAllPopups() {
		slider.querySelectorAll(".species-spotlight__popup").forEach(popup => {
			popup.classList.remove("active");
		});
		if (
			flickityInstance &&
			typeof flickityInstance.updateDraggable === "function"
		) {
			flickityInstance.options.draggable = true;
			flickityInstance.updateDraggable();
		}
	}

	popupButtons.forEach(button => {
		button.addEventListener("click", function (e) {
			e.preventDefault();
			e.stopPropagation();

			// Close any open popups first
			closeAllPopups();

			// Get the parent cell and its popup
			const cell = this.closest(".species-spotlight__cell");
			const popup = cell.querySelector(".species-spotlight__popup");

			// Open the popup
			popup.classList.add("active");

			// Disable Flickity dragging when popup is open
			flickityInstance.options.draggable = false;
			flickityInstance.updateDraggable();
		});
	});

	closeButtons.forEach(button => {
		button.addEventListener("click", function (e) {
			e.preventDefault();
			e.stopPropagation();
			closeAllPopups();
		});
	});

	// Close popup when clicking outside
	document.addEventListener("click", function (e) {
		if (
			!e.target.closest(".species-spotlight__popup") &&
			!e.target.closest(".species-spotlight__popup-button")
		) {
			closeAllPopups();
		}
	});
}

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
	// Try to initialize immediately
	const initialFlkty = initSpeciesSlider();

	// If initialization failed or slider wasn't ready, retry with a small delay
	if (!initialFlkty) {
		setTimeout(initSpeciesSlider, 500);
	}
});

// Also initialize on window.onload to ensure all resources are loaded
window.addEventListener("load", function () {
	// If the slider exists but isn't properly initialized, reinitialize it
	const slider = document.querySelector(
		".species-spotlight .species-spotlight__slider"
	);
	if (
		slider &&
		(!speciesFlkty || !slider.classList.contains("flickity-enabled"))
	) {
		initSpeciesSlider();
	}

	// Force a resize in case images changed the layout
	if (speciesFlkty) {
		setTimeout(() => {
			speciesFlkty.resize();
		}, 100);
	}
});
